<template>
  <!-- Filas de carga con la forma de los listados en tarjetas (lc-list) -->
  <div class="lc-list">
    <div v-for="n in count" :key="n" class="lc-item">
      <v-skeleton-loader :type="avatar ? 'list-item-avatar-two-line' : 'list-item-two-line'" class="skeleton-row" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ListSkeletonRows",
  props: {
    count: {
      type: Number,
      default: 5,
    },
    avatar: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.skeleton-row {
  width: 100%;
}
.skeleton-row >>> .v-skeleton-loader__list-item-avatar-two-line,
.skeleton-row >>> .v-skeleton-loader__list-item-two-line {
  background: transparent;
  padding: 0;
}
</style>
